import { useEffect, useState } from "react";
import { Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const EMPTY = {
  company_name: "", name: "", vat_number: "", phone: "", email: "",
  website: "", address: "", cap: "", city: "",
};

export const SupplierQuickCreateModal = ({ open, onClose, onCreated }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setForm(EMPTY); }, [open]);
  if (!open) return null;

  const set = (key, value) => setForm(current => ({ ...current, [key]: value }));
  const save = async () => {
    if (!form.company_name.trim()) {
      toast.error("La ragione sociale è obbligatoria");
      return;
    }
    setSaving(true);
    try {
      const response = await api.post("/suppliers", form);
      onCreated(response.data);
      toast.success("Fornitore creato");
      onClose();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Errore creazione fornitore");
    } finally { setSaving(false); }
  };

  const fields = [
    ["company_name", "Ragione sociale *"], ["name", "Nome referente"],
    ["vat_number", "P.IVA"], ["phone", "Telefono"], ["email", "Email"],
    ["website", "Sito web"], ["address", "Indirizzo", true],
    ["cap", "CAP"], ["city", "Città"],
  ];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4"
         onClick={onClose} data-testid="supplier-quick-modal">
      <div className="bg-white w-full max-w-2xl border border-[#E5E5E0] shadow-xl max-h-[90vh] overflow-y-auto"
           onClick={event => event.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#F0F0EA]">
          <h2 className="font-serif text-xl">Nuovo Fornitore</h2>
          <button onClick={onClose} className="text-[#707070] hover:text-[#1A1A1A]"
                  aria-label="Chiudi" data-testid="supplier-quick-close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {fields.map(([key, label, wide]) => (
            <div key={key} className={wide ? "sm:col-span-2" : ""}>
              <label className="label-tiny" htmlFor={`supplier-quick-${key}`}>{label}</label>
              <input id={`supplier-quick-${key}`} className="input-luxury"
                     autoFocus={key === "company_name"} value={form[key]}
                     onChange={event => set(key, event.target.value)}
                     data-testid={`supplier-quick-${key}`} />
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#F0F0EA]">
          <button onClick={onClose} className="btn-ghost text-sm" data-testid="supplier-quick-cancel">Annulla</button>
          <button onClick={save} disabled={saving} className="btn-primary text-sm inline-flex items-center gap-2"
                  data-testid="supplier-quick-save">
            {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
            {saving ? "Salvataggio..." : "Salva"}
          </button>
        </div>
      </div>
    </div>
  );
};